<template>
  <div class="clutch-specifications" v-html="note"></div>
</template>

<script>
export default {
  props: {
    note: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.clutch-specifications {
  border-radius: 4px;
  padding: 10px 14px;
  background: #fdf7fa;
  border-left: 6px solid $v4_success_green;
}
.clutch-specifications p {
  margin: 5px 0 0;
  font-size: 13px;
}
</style>
